import { LoanType } from '../../../../../../../../../common/constants/LoanType';
import { LoanForm } from '../constants/loanForm';

/**
 * Whether "Same as Committed" starts checked (same rule as EditStdLoanModal's populateState): only for Bridge loans,
 * and only when Prom. Note/Com., Apprvd Loan Amt and Bridge Funded already agree, including all three empty, so a new
 * Bridge loan starts locked and one entry fills all three.
 */
export const getSameAsCommitted = (loanTypeId: LoanType | undefined, form: LoanForm) =>
    loanTypeId === LoanType.Bridge &&
    form.commitment === form.promissoryNote &&
    form.bridgeFunded === form.promissoryNote;
